export default __webpack_public_path__ + "static/media/Group9246.e195dd75.svg";